<template>
  <article :class="[`pt-article pt-article-${size}`, { 'shadow-md': showVideo && thumbnail }]">
    <div :class="`pt-article-${dir}`">
      <div :class="`pt-article__box-img-${size}-${dir}`">
        <div @click.stop.prevent="onClickMultimedia">
          <template v-if="media">
            <template v-if="thumbnail">
              <video
                ref="video"
                v-lazy-load
                class="w-full"
                :class="{ 'opacity-0': !showVideo }"
                loop
                :controls="!showVideo"
                muted
                playsinline
                preload="metadata"
              >
                <source :src="media.url" type="video/mp4" />
              </video>
            </template>
            <NuxtImg
              v-else
              :key="media.url"
              :alt="media.alternativeText || title"
              :src="media.url"
              class="hover:opacity-70 w-[220px]"
              loading="lazy"
            />
          </template>
        </div>
      </div>
      <div v-if="title" :class="`pt-article__box-content-${size}-${dir}`">
        <component :is="titeTag">
          {{ title }}
        </component>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: 'PtVideo',
  props: {
    media: {
      type: Object,
      default: () => ({})
    },
    url: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'xs',
      validator: val => ['xs', 'md', 'lg'].includes(val)
    },
    dir: {
      type: String,
      default: 'col',
      validator: val => ['row', 'col'].includes(val)
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    titeTag: {
      type: String,
      default: 'h2'
    }
  },
  emits: ['show-video'],
  data: () => ({ showVideo: false }),
  mounted() {
    if (this.$refs.video) this.$refs.video.play();
    this.setVideoShow();
  },
  methods: {
    onClickMultimedia() {
      this.$emit('show-video', this.url);
    },
    setVideoShow() {
      if (!this.showVideo) this.showVideo = true;
    }
  }
};
</script>
<style src="../Article/style.scss" lang="scss" />
